import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Stack, Typography, Button } from "@mui/material";

import { WhiteTextField } from "./styles";

const SubscribeSection = ({ onSubscribe = () => {} }) => {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubscribe();
  };

  return (
    <Stack gap="12px" component="form" onSubmit={handleSubmit}>
      <Typography color="white" variant="body2">
        {t("footer.subscribe_to_our_newsletter")}
      </Typography>
      <Stack gap="1rem" direction={{ xs: "column", md: "row" }}>
        <WhiteTextField
          type="email"
          variant="outlined"
          placeholder={t("footer.enter_your_email")}
          autoComplete="off"
          size="small"
          fullWidth
          required
        />
        <Button size="large" type="submit" color="primary" variant="subscribe">
          <span>{t("footer.subscribe")}</span>
        </Button>
      </Stack>
    </Stack>
  );
};

export default SubscribeSection;
